export default {
    upgradeLine: 'อัปเดตไลน์',
    lineSeriveIsUpdated: 'ระบบไลน์ถูกอัปเดตแล้ว',
    congratulation: 'ยินดีดัวย'
}
